import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Home, ArrowLeft } from 'lucide-react';
import { SEO } from '@/components/SEO';

export default function NotFoundPage() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4" data-testid="not-found-page">
      <SEO title="Sayfa Bulunamadı" description="Aradığınız sayfa bulunamadı." />
      <div className="text-center max-w-md">
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <div className="w-20 h-20 rounded-full bg-[#F5F3EF] flex items-center justify-center mx-auto mb-6">
            <Search size={32} className="text-[#D8C7A6]" />
          </div>
          <h1 className="font-heading text-[42px] sm:text-[46px] font-bold text-[#1F2937] mb-3">404</h1>
          <h2 className="font-heading text-[24px] font-semibold text-[#1F2937] mb-3">Sayfa Bulunamadı</h2>
          <p className="text-[14px] text-[#5F6B76] leading-relaxed mb-8">
            Aradığınız sayfa taşınmış, kaldırılmış veya hiç var olmamış olabilir.
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
              <Link
                to="/"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#1F6E7A] text-white text-sm font-semibold hover:bg-[#185960] transition-colors"
              >
                <Home size={16} /> Ana Sayfaya Dön
              </Link>
            </motion.div>
            <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
              <Link
                to="/hizmetler"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-[#E7E5E4] text-sm font-semibold hover:bg-[#F5F3EF] transition-colors"
              >
                <ArrowLeft size={16} /> Tedavileri İncele
              </Link>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
